import React, {useState}							from 'react';

import Modal										from '../Modal';
import Input										from '../Input';
import Icon											from '../Icon';

import {useAppSelector}								from '../../../app/hooks';
import {InputValues}								from '../Input/interface';

import img_smile									from '../../images/icon/face-smile.svg';

import LANGUAGE										from '../../language';

import './ModalTags.css';
import ft_cssVar from '../../functions/getCssVar';
import {ModalTagsProps} from './interface';


function ModalTags(props: ModalTagsProps) {
	const lang = useAppSelector(state => state.settings.lang);

	const [tagsList, set_tagsList] = useState(props.tags);
	const [newTag, set_newTag] = useState<InputValues>('');

	const TEXTE = LANGUAGE(lang);

	return (
		<Modal
			footerSeparation
			onClose={props.onClose}
			confirmLoad={props.load}
			cancelButton={props.onClose}
			footerFlexDirection={'column-reverse'}
			confirmButton={() => props.onConfirm(tagsList)}
			confirmButtonText={TEXTE.global.validateSelection}
			header={
				<Icon
					iconBorder
					size={36}
					iconSize={24}
					borderSize={8}
					icon={img_smile}
					iconColor={ft_cssVar('primary-600')}
				/>}
		>
			<div className={'modalTagsContainer'}>
				<div className={'modalTagsText'}>
					<span>{TEXTE.global.tagsTitle}</span>
					<span>{TEXTE.global.tagsDescription}</span>
				</div>
				<Input
					value={newTag}
					tags={tagsList}
					onChange={set_newTag}
					setTags={set_tagsList}
					allTags={props.allTags.sort((a, b) => a.name.localeCompare(b.name))}
				/>
				<span className={'text-sm weight-400 gray-600'}>{TEXTE.global.tagsPressEnter}</span>
			</div>
		</Modal>
	);
}

export default ModalTags;